<template>

  <el-container style="margin-top: 30px;margin-left: 50px;width: 100%;margin-bottom: 50px;">
    <div style="width: 60%;">
      <el-row :span="2">
      	<el-col :span="20" style="text-align: center;">
      	  <el-upload
      	      class="upload-demo"
      	      ref="upload1"
      	      :action="action()"
      	      :on-preview="handlePreview"
      	      :before-upload="beforeUpload"
      	      :data="uploadData"
      	      :on-error = "error"
      	      :on-success="successResave"
      	      :on-remove="handleRemove"
      	      :file-list="fileList"
      	      :auto-upload="false">
      	      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      	      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>

      	  </el-upload>

      	</el-col>
      </el-row>
      <el-row :span="2" style="margin-top: 50px;text-align: center;" v-for="(items,indexs) in datas">
        <h2 style="margin-right: 25%;">{{items.name}}</h2>
        <el-col :span="6" style="border-radius: 0px;border:1px solid #ccc;height: 500px;overflow-x:scroll;">
          <h2>拆分</h2>
          <el-button  class="button-new-tag" size="small" @click="paixu(indexs)">重新排序</el-button>
          <el-row v-for="(itemc,indexc) in items.datac" style="margin-top: 10px;">

            <el-col :span="4" style="margin-left: 20%;margin-top: 10px;">{{itemc.name}}</el-col>
            <el-col :span="4" @click.native="handleClosec(indexs,itemc.num)" style="margin-top: 10px;">删除</el-col>
            <el-col :span="4"><el-input v-model="itemc.num" style="width: 50px;"></el-input></el-col>
          </el-row>
          <el-row style="margin-top: 10px;margin-bottom: 30px;" >
            <el-input
              class="input-new-tag"
              v-if="items.inputVisiblec"
              v-model="items.inputValuec"
              ref="saveTagInputc"
              size="small"
              @keyup.enter.native="handleInputConfirmc(indexs)"
              @blur="handleInputConfirmc(indexs)"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInputc(indexs)">添加拆分</el-button>
          </el-row>
        </el-col>
        <el-col :span="6" style="border-radius: 0px;border:1px solid #ccc;height: 500px;overflow-x:scroll;">
          <h2>组合</h2>
          <el-row>
            <el-tag
              v-for="tag in items.dataz"
              :key="tag"
              type="success"
              closable
              @close="handleClosez(tag,indexs)"
              style="width: 60%;margin-top: 10px;">
              {{tag}}

            </el-tag>

          </el-row>
          <el-row style="margin-top: 10px;margin-bottom: 30px;" v-if="items.datac.length > 0">
            <el-input
              class="input-new-tag"
              v-if="items.inputVisible"
              v-model="items.inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm(indexs)"
              @blur="handleInputConfirm(indexs)"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput(indexs)">添加组合</el-button>
          </el-row>
        </el-col>
        <el-col :span="6" style="border-radius: 0px;border:1px solid #ccc;height: 500px;overflow-x:scroll;">
          <h2>拆分+组合</h2>
          <el-row v-for="(name,index) in items.data" style="margin-top: 10px;">
            {{name}}

          </el-row>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 100px;text-align: center;width: 20%;">
      <h2>合集</h2>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="allData">组合结果</el-button>

      <!-- <el-row :span="2"  style="margin-top: 50px;text-align: center;border-radius: 0px;border:1px solid #ccc;height: 1000px;overflow-x:scroll;">
          <el-row v-for="(name,index) in dataAll" style="margin-top: 10px;">
            {{name}}

          </el-row>

      </el-row> -->
      <el-input
        type="textarea"
        :rows="55"
        placeholder=""
        v-model="textarea">
      </el-input>
    </div>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
        name:'',
        datas:[],
        data:[],
        datac:[],
        dataz:[],
        inputVisible: false,
        inputValue: '',
        inputVisiblec: false,
        inputValuec: '',
        uploadData:{},
        file:'',
        fileList:[],
        dataAll:[],
        textarea:''

      }
    },
  directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }

    },

  methods:{

    allData(){
      this.dataAll = []
      var  cc = ''
      this.datas.forEach((items,indexs) => {
        items.data.forEach((item,index) => {
          if(this.dataAll.indexOf(item) == -1){
            this.dataAll.push(item)
            if(cc == ''){
              cc = item
            }else{
              cc = cc +'\n'+item
            }
          }
          



        })
      })
      this.textarea = cc
    },
    action(){
      return "http://waixingren.yoooooo.com/jiebaYuyanX"
    },
    submitUpload() {
      this.$refs.upload1.submit();
      let formData = new FormData();


    },
    handleRemove(file, fileList) {

    },
    handlePreview(file) {

       console.log(file);
     },
     beforeUpload (file) {

        this.uploadData = {lid:0,type:'ciku'};
        console.log(this.choses)

           let promise = new Promise((resolve) => {
               this.$nextTick(function () {
                   resolve(true);
               });
           });
           return promise;
    },
    //上传成功钩子
    successResave(response, file, fileList){
      this.datas = response.data
      // console.log(response)
      if(response.code==200){
         alert('上传成功')

      }
    },
    //失败钩子
     error(response, file, fileList){
           console.log(response)
     },
    sortKey(array,key){
      return array.sort(function(a,b){
        var x = a[key];
        var y = b[key];
        return ((x<y)?-1:(x>y)?1:0)
      })
    },
    paixu(indexs){
      this.datas[indexs]['datac'] = this.sortKey(this.datas[indexs]['datac'],'num')
      this.datas[indexs]['data'] = []
      this.datas[indexs]['dataz'] = []
      var a = 1
      this.datas[indexs]['datac'].forEach((j,index) => {
        var b = 0
        this.datas[indexs]['datac'].forEach((k,index) => {
          b = b+1
          if(b>a){
            this.datas[indexs]['dataz'].push(j['name']+k['name'])
          }

        })
        a = a+1
      })
      var x = 1
      this.datas[indexs]['datac'].forEach((j,index) => {
        var y = 0
        this.datas[indexs]['datac'].forEach((k,index) => {
          y = y+1
          if(y>x){
            var z = 0
            this.datas[indexs]['datac'].forEach((l,index) => {
              z = z+1
              if(z > y){
                this.datas[indexs]['dataz'].push(j['name']+k['name']+l['name'])
              }

            })

          }

        })
        x = x+1
      })
      this.datas[indexs]['datac'].forEach((element,index) => {
        this.datas[indexs]['data'].push(element.name)
      })
      this.datas[indexs]['dataz'].forEach((element,index) => {
        this.datas[indexs]['data'].push(element)
      })
    },

    showInput(indexs) {
      this.datas[indexs].inputVisible = true;

    },
    handleInputConfirm(indexs) {
      let inputValue = this.datas[indexs].inputValue;
      if (inputValue) {
        this.datas[indexs]['dataz'].push(inputValue);
        this.datas[indexs]['data'] = []
        this.datas[indexs]['datac'].forEach((element,index) => {
          this.datas[indexs]['data'].push(element.name)
        })
        this.datas[indexs]['dataz'].forEach((element,index) => {
          this.datas[indexs]['data'].push(element)
        })
      }
      this.datas[indexs].inputVisible = false;
      this.datas[indexs].inputValue = '';
    },
    showInputc(indexs) {
      this.datas[indexs].inputVisiblec = true;

    },
    handleInputConfirmc(indexs) {
      let inputValuec = this.datas[indexs].inputValuec;
      if (inputValuec) {
        this.datas[indexs]['datac'].push({'name':inputValuec,'num':this.datas[indexs]['datac'].length+1});
        this.datas[indexs]['data'] = []
        this.datas[indexs]['dataz'] = []
        var a = 1

       this.datas[indexs]['datac'].forEach((j,index) => {
          var b = 0
          this.datas[indexs]['datac'].forEach((k,index) => {
            b = b+1
            if(b>a){
             this.datas[indexs]['dataz'].push(j['name']+k['name'])
            }

          })
          a = a+1
        })
        var x = 1
        this.datas[indexs]['datac'].forEach((j,index) => {
          var y = 0
          this.datas[indexs]['datac'].forEach((k,index) => {
            y = y+1
            if(y>x){
              var z = 0
              this.datas[indexs]['datac'].forEach((l,index) => {
                z = z+1
                if(z > y){
                  this.datas[indexs]['dataz'].push(j['name']+k['name']+l['name'])
                }

              })

            }

          })
          x = x+1
        })
        this.datas[indexs]['datac'].forEach((element,index) => {
          this.datas[indexs]['data'].push(element.name)
        })
        this.datas[indexs]['dataz'].forEach((element,index) => {
          this.datas[indexs]['data'].push(element)
        })
      }
      this.datas[indexs].inputVisiblec = false;
      this.datas[indexs].inputValuec = '';
    },
    handleClosec(indexs,index) {
      this.datas[indexs]['datac'].splice(index-1, 1);
      //111111111111111111111111111111111111
      this.datas[indexs]['datac'].forEach((k,indexa) => {

        this.datas[indexs]['datac'][indexa]['num'] = indexa+1
      })
      this.datas[indexs]['data'] = []
      this.datas[indexs]['dataz'] = []
      var a = 1
      this.datas[indexs]['datac'].forEach((j,index) => {
        var b = 0
        this.datas[indexs]['datac'].forEach((k,index) => {
          b = b+1
          if(b>a){

            this.datas[indexs]['dataz'].push(j['name']+k['name'])
          }

        })
        a = a+1
      })
      var x = 1
      this.datas[indexs]['datac'].forEach((j,index) => {
        var y = 0
        this.datas[indexs]['datac'].forEach((k,index) => {
          y = y+1
          if(y>x){
            var z = 0
            this.datas[indexs]['datac'].forEach((l,index) => {
              z = z+1
              if(z > y){
                this.datas[indexs]['dataz'].push(j['name']+k['name']+l['name'])
              }

            })

          }

        })
        x = x+1
      })
      this.datas[indexs]['datac'].forEach((element,index) => {
        this.datas[indexs]['data'].push(element.name)
      })
      this.datas[indexs]['dataz'].forEach((element,index) => {
        this.datas[indexs]['data'].push(element)
      })

    },
    handleClosez(tag,indexs) {
      this.datas[indexs]['dataz'].splice(this.dataz.indexOf(tag), 1);
      this.datas[indexs]['data'] = []
      this.datas[indexs]['datac'].forEach((element,index) => {
        this.datas[indexs]['data'].push(element.name)
      })
      this.datas[indexs]['dataz'].forEach((element,index) => {
        this.datas[indexs]['data'].push(element)
      })
    },

    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/cjiebax.vue